import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ejectHistoryAction, ejectDetailsAction, checkUserExistsAction } from "../actions/EjectActions";

interface EjectState {
  ejectHistory: any[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
  details: any | null;
  userExists: boolean | null;
  loading: boolean;
  error: string | null;
}

const initialState: EjectState = {
  ejectHistory: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 5,
  },
  details: null,
  userExists: null,
  loading: false,
  error: null,
};

const ejectSlice = createSlice({
  name: "eject",
  initialState,
  reducers: {
    clearEjectDetails: (state) => {
      state.details = null;
      state.userExists = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Eject History
      .addCase(ejectHistoryAction.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(ejectHistoryAction.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        // Server returns: { data: { ejectRequests }, pagination }
        state.ejectHistory = action.payload?.data?.ejectRequests || [];
        state.pagination = action.payload?.pagination || initialState.pagination;
      })
      .addCase(ejectHistoryAction.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch eject history";
      })

      // Eject Details
      .addCase(ejectDetailsAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(ejectDetailsAction.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(ejectDetailsAction.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch eject details";
      })

      // Check User Existence
      .addCase(checkUserExistsAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkUserExistsAction.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.userExists = action.payload?.data?.exists;
      })
      .addCase(checkUserExistsAction.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to check user existence";
      });
  },
});

export const { clearEjectDetails } = ejectSlice.actions;
export default ejectSlice.reducer;
